import react, { useState, useRef } from 'react';

function ReceiptDropZone({ onFileSelected, disabled, uploading }) {
    const [dragActive, setDragActive] = useState(false);
    const inputRef = useRef();

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === 'dragenter' || e.type === 'dragover') {
            setDragActive(true);
        } else if (e.type === 'dragleave') {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (disabled || uploading) return;
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const file = e.dataTransfer.files[0];
            if (isValidFile(file)) {
                onFileSelected(file);
            } else {
            alert('Only image or PDF files are allowed.');
            }
        }
    };

    const handleChange = (e) => {
        if (disabled || uploading) return;
        const file = e.target.files[0];
        if (file && isValidFile(file)) {
            onFileSelected(file);
        } else if (file) {
            alert('Only image or PDF files are allowed.');
        }
    };

    function isValidFile(file) {
        return file.type.startsWith('image/') || file.type === 'application/pdf';
    }

    return (
        <div
            onDragEnter={handleDrag}
            onDragOver={handleDrag}
            onDragLeave={handleDrag}
            onDrop={handleDrop}
            style={{
                border: dragActive ? '2px solid #007bff' : '2px dashed #aaa',
                borderRadius: 6,
                padding: 12,
                background: dragActive ? '#e6f0ff' : '#fafbfc',
                cursor: disabled ? 'not-allowed' : 'pointer',
                minWidth: 180,
                display: 'inline-block',
                position: 'relative',
                textAlign: 'center',
                opacity: disabled ? 0.6 : 1
            }}
            onClick={() => !disabled && inputRef.current && inputRef.current.click()}
            tabIndex={0}
            role="button"
            aria-disabled={disabled}
        >
            <input
                ref={inputRef}
                type="file"
                accept="image/*,application/pdf"
                style={{ display: 'none' }}
                onChange={handleChange}
                disabled={disabled}
            />
            {uploading ? (
                <span>Uploading...</span>
            ) : (
                <span>{dragActive ? 'Drop file here' : 'Click or drag image/PDF here'}</span>
            )}
        </div>
        );
}

export default ReceiptDropZone;